jQuery(document).ready(function($) {
  if($('body').hasClass('woocommerce-account')) {
    var error = $('.woocommerce-error');
    var loginForm = $('.woocommerce-form-login');

    if (error && loginForm.length > 0) {
      loginForm.addClass('has-errors');

      error.find('li').each(function(index, element) {
        var message = $(element).text();

        if (message.toLowerCase().indexOf("password") >= 0) {
          $('.pass-col').addClass('error');
          $('.pass-col .input-wrap').append('<i class="material-icons">close</i>').append('<div class="error-msg">Password is incorrect</div>');
        }

        if (message.toLowerCase().indexOf("username") >= 0) {
          $('.user-col').addClass('error');
          $('.user-col .input-wrap').append('<i class="material-icons">close</i>').append('<div class="error-msg">E-mail is incorrect</div>');
        }
        else {
          $('.user-col .input-wrap').append('<i class="material-icons">check</i>');
        }

      });
    }
  }
});
